import { phpRequest } from "./phpRequest";

export const exportSubscriptionAPI = async (subscribeValueAddedServiceId) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const data = await phpRequest.post("/subscribe/export", {
    subscribe_value_added_service_id: subscribeValueAddedServiceId,
    timezone: timezone,
  });

  return data.download_link;
};
